// extracted by mini-css-extract-plugin
export var typingIndicator = "_pi-0";